export const RECIPIENTS_TYPE_REGULAR = 'regular';
export const RECIPIENTS_TYPE_AUTOMATED = 'automated';
export const RECIPIENTS_TYPE_MODERATED = 'moderated';
